module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "hero app-navbar"
  }, [_c('div', {
    staticClass: "hero-head"
  }, [_c('nav', {
    staticClass: "navbar"
  }, [_c('div', {
    staticClass: "navbar-brand"
  }, [_c('div', {
    class: {
      'navbar-burger': true, 'burger': true, 'is-active': !_vm.showBurger
    },
    on: {
      "click": function($event) {
        _vm.$emit('toggleSidebar')
      }
    }
  }, [_c('span'), _vm._v(" "), _c('span'), _vm._v(" "), _c('span')]), _vm._v(" "), _c('div', {
    staticClass: "navbar-item is-size-5 has-text-weight-light"
  }, [_vm._v(_vm._s(this.$store.state.organization.name))])]), _vm._v(" "), _c('div', {
    staticClass: "navbar-menu"
  }, [_c('div', {
    staticClass: "navbar-end"
  }, [_c('div', {
    staticClass: "navbar-item has-dropdown is-hoverable"
  }, [_c('a', {
    staticClass: "navbar-link"
  }, [_c('p', [_vm._m(0), _vm._v(" " + _vm._s(this.$store.state.customer.name))])]), _vm._v(" "), _c('div', {
    staticClass: "navbar-dropdown is-right"
  }, [_vm._l((this.$store.state.organizations), function(organization) {
    return _c('div', [_c('a', {
      class: {
        'navbar-item': true, 'is-active': _vm.organizationIsActive(organization.id)
      },
      on: {
        "click": function($event) {
          _vm.switchOrganization(organization.id)
        }
      }
    }, [_c('div', {
      staticClass: "field"
    }, [_c('p', [_vm._v(_vm._s(organization.name))]), _vm._v(" "), _c('p', {
      staticClass: "has-text-grey-light"
    }, [_vm._v("id: " + _vm._s(organization.id) + " | slug: " + _vm._s(organization.slug))])])])])
  }), _vm._v(" "), _c('hr', {
    staticClass: "navbar-divider"
  }), _vm._v(" "), _c('a', {
    staticClass: "navbar-item",
    on: {
      "click": _vm.logout
    }
  }, [_vm._m(1), _vm._v(" "), _c('span', [_vm._v("Log out")])])], 2)])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-lg fa-user-circle-o"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-lg fa-sign-out"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b1f2c612"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/layout/Navbar.vue
// module id = 228
// module chunks = 1